import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { GenericTable } from '../../components/_EOS/Table'
import { TypePriority } from '../../interfaces'
import { useModal } from '../../hooks/useModal'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import { usePagination } from '../../hooks/usePagination'
import {
  createTypePriority,
  getTypePriority,
  putTypePriority
} from './config/api'
import { Status } from '../../hooks/useFetchState'
import { Modal } from '../../components/_EOS/Modal'
import { TypePriorityForm } from './forms'
import { PrioritySearch } from './PrioritySearch'
import { priorityTableHeaderConfigs } from './config/config'
import { useTypesPriority } from '../../hooks/useTypesPriority'

interface TypePriorityPageProps {}

export const TypePriorityPage: React.FC<TypePriorityPageProps> = () => {
  const [searchPriority, setSearchPriority] = useState('')

  const editModal = useModal<TypePriority>('Editar Prioridad', false, 'xs')

  const createModal = useModal('Crear webhook')

  const { state, callApi } = useApi<ApiResponse<TypePriority>>()

  const pagination = usePagination(10)

  const requestGetTypePriority = (page: number, pageSize: number) => {
    callApi(getTypePriority(page, pageSize, searchPriority))
  }

  const requestPutTypePriority = (dto: TypePriority) => {
    callApi(putTypePriority(dto))
  }

  const requestPostTypePriority = (dto: TypePriority) => {
    callApi(createTypePriority(dto))
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    if (pageSize === pagination.pageSize) {
      requestGetTypePriority(page, pageSize)
      pagination.setPagination(page, pageSize)
    } else {
      requestGetTypePriority(0, pageSize)
      pagination.setPagination(0, pageSize)
    }
  }

  const {
    getTypesPriority,
    typesPriorityState: { typesPriority }
  } = useTypesPriority()

  useEffect(() => {
    if (!typesPriority || typesPriority?.length <= 0) {
      getTypesPriority()
    }
  }, [])

  useEffect(() => {
    requestGetTypePriority(pagination.page, pagination.pageSize)
  }, [])

  return (
    <Fragment>
      <StandardPage
        pageTitle='Administrador de Prioridades'
        buttonAction={() => createModal.openModal('md')}
        // buttonTitle='Crear Prioridades'
      >
        <PrioritySearch
          searchValue={searchPriority}
          onChangeSearchValue={setSearchPriority}
          handleSearch={() => requestGetTypePriority(0, pagination.pageSize)}
        />

        <GenericTable<TypePriority>
          headersConfig={priorityTableHeaderConfigs}
          IDKey={'typePriorityId'}
          data={state.data?.items}
          actions={{
            onEdit: (_id, row) => editModal.openModal('md', row),
            onDelete: (_id) => editModal.openModal('md')
          }}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
        />
      </StandardPage>

      <Modal
        open={editModal.isOpen}
        maxWidth={editModal.size}
        title={editModal.title}
        onClose={editModal.closeModal}
      >
        <TypePriorityForm
          initialValues={editModal.extendedProps!}
          onSubmit={async (vals) => {
            requestPutTypePriority(vals)
          }}
          onCancel={editModal.closeModal}
        />
      </Modal>

      <Modal
        open={createModal.isOpen}
        maxWidth={createModal.size}
        title={createModal.title}
      >
        <TypePriorityForm
          initialValues={{ typePriorityId: 0, name: '', value: 0 }}
          onSubmit={async (vals) => {
            requestPostTypePriority(vals)
          }}
          onCancel={createModal.closeModal}
        />
      </Modal>
    </Fragment>
  )
}
